import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { widgetData } from './Dashboard.data'; // Corregido el nombre del archivo
import Widget from '../components/common/Widget';
import { canAccessReportes } from '../helpers/session';

const DashboardContainer = styled.div`
  padding: 40px;
`;

const WidgetsGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  /* ✅ Aumentamos el espacio para que las animaciones respiren */
  gap: 32px; 
`;

// Mantenemos una animación de contenedor para la carga inicial
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
    },
  },
};

const DashboardPage: React.FC = () => {
  // ✅ 1. Estado para saber qué widget está enfocado
  const [focusedWidgetId, setFocusedWidgetId] = useState<string | null>(null);
  const widgets = widgetData.filter((widget) =>
    widget.path === '/reportes' ? canAccessReportes() : true,
  );

  return (
    <DashboardContainer>
      <WidgetsGrid
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {widgets.map((widget) => (
          // ✅ 2. Pasamos el estado y las funciones como props a cada Widget
          <Widget
            key={widget.title}
            data={widget}
            isFocused={focusedWidgetId === widget.title}
            isOtherFocused={focusedWidgetId !== null && focusedWidgetId !== widget.title}
            onFocus={() => setFocusedWidgetId(widget.title)}
            onBlur={() => setFocusedWidgetId(null)}
          />
        ))}
      </WidgetsGrid>
    </DashboardContainer>
  );
};

export default DashboardPage;